import polyglotI18nProvider from "ra-i18n-polyglot";
import japaneseMessages from "ra-language-japanese";

const customJapaneseMessages = {
  ...japaneseMessages,
    ra: {
        ...japaneseMessages.ra,
        message:{
            ...japaneseMessages.ra?.message,
            delete_title: '削除'
        },
        action: {
            ...japaneseMessages.ra?.action,
            confirm: '削除する',  
        }
    }
};

const i18nProvider = polyglotI18nProvider(() => customJapaneseMessages, "ja");



export default i18nProvider;